<app-modal-frame [headerText]="CONSTANTS.EDIT_STOP" (emitExit)="onClose()">
  <div class="popup-content">
    <form
      [formGroup]="editTrackingDetailForm"
      (keydown.enter)="$event.preventDefault()"
    >
      <div class="popup-header">
        <!-- Left top section -->
        <div class="left-header header-containers">
          <app-edit-stop-left-section
            [data]="data.routeDetails"
            [viewIndex]="data.viewIndex"
          ></app-edit-stop-left-section>
        </div>

        <!-- Right top section -->
        <div class="right-header header-containers">
          @let packageExists = packageDetailsExists$ | async;

          <ion-row class="property-container second-row even-gutter">
            <!-- Density -->
            <ion-col size="3">
              <app-form-select
                [label]="CONSTANTS.DENSITY"
                [options]="DENSITY_LIST"
                [formControlName]="'density'"
                [required]="true"
              >
              </app-form-select>
            </ion-col>

            <!-- Complete Time -->
            <ion-col size="3" class="ion-justify-content-end">
              <app-form-time-picker
                [headerText]="CONSTANTS.COMPLETE_TIME"
                [placeholderText]="CONSTANTS.COMPLETE_TIME_PLACEHOLDER"
                [form]="editTrackingDetailForm"
                [altIconSpacing]="true"
                [control]="'completionTime'"
                (inputChangedEvent)="updateTime()"
              ></app-form-time-picker>
            </ion-col>

            <!-- Clarify (DS only) -->
            @if (data.routeDetails[0].type === "DS") {
              <ion-col size="3">
                <div class="asterick-col">
                  {{ CONSTANTS.CLARIFY }}
                  @if (isSignatureRequired) {
                    <span class="clarify-asterick">*</span>
                  }
                </div>

                <app-form-text-field
                  [maxLength]="15"
                  [form]="editTrackingDetailForm"
                  [control]="'clarify'"
                  [hasRequiredSign]="false"
                  (keypress)="preventSpecialCharactersWithSpaces($event)"
                ></app-form-text-field>
              </ion-col>
            }

            <!-- Info notice (digits-only, max 12) -->
            @if (data.routeDetails[0].type === "DS") {
              <ion-col size="3">
                <div class="asterick-col">
                  {{ CONSTANTS.INFO_NOTICE }}
                </div>

                <app-form-text-field
                  [maxLength]="12"
                  [form]="editTrackingDetailForm"
                  [control]="'infoNotice'"
                  [regexType]="SpecialCharacters.NUMBER_ONLY"
                  [inputmode]="'numeric'"
                  [hasRequiredSign]="false"
                ></app-form-text-field>
              </ion-col>
            }
          </ion-row>

          <ion-row>
            <!-- Stop Date -->
            <ion-col size="4">
              <div>
                {{ CONSTANTS.STOP_DATE }}
              </div>
              <app-form-date-picker
                formControlName="stopDate"
                [placeholder]="CONSTANTS.DATE_PLACEHOLDER"
                [minDate]="minDate"
                [maxDate]="currentDate"
                [required]="false"
              ></app-form-date-picker>
            </ion-col>

            <!-- Common Scan Code -->
            <ion-col size="4">
              <div>
                {{ CONSTANTS.SCAN_CODE }}
                @if (packagedDeliveryStop) {
                  <span class="required">*</span>
                }
              </div>

              <div class="form-group scan-code">
                <ng-select
                  appearance="outline"
                  class="custom-select scan-codes-select"
                  [formControlName]="'commonScanCode'"
                  [clearable]="false"
                  (change)="scanCodeOverride(false)"
                >
                  @for (option of scanCodeVals; track option) {
                    <ng-option class="option" [value]="option.value">
                      {{ option.label }}
                    </ng-option>
                  }
                </ng-select>

                @if (
                  editTrackingDetailForm.get("commonScanCode")?.invalid &&
                  (editTrackingDetailForm.get("commonScanCode")?.dirty ||
                    editTrackingDetailForm.get("commonScanCode")?.touched)
                ) {
                  <div class="alert validation-message">
                    @if (
                      editTrackingDetailForm
                        .get("commonScanCode")
                        ?.hasError("required")
                    ) {
                      <span>
                        {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                      </span>
                    }
                  </div>
                }
              </div>
            </ion-col>

            <!-- No package Status (PS only) -->
            @if (data.routeDetails[0].type === "PS" && !packageExists) {
              <ion-col size="4">
                <div class="no-package-pickup-status">
                  {{ CONSTANTS.NO_PKG_STATUS }}
                  @if (!packageExists) {
                    <span class="required">*</span>
                  }
                </div>
                <ng-select
                  appearance="outline"
                  class="custom-select scan-codes-select"
                  [formControlName]="'noPackagePickupStatus'"
                  [clearable]="false"
                  [required]="false"
                >
                  @for (
                    option of noPackagePickupStatusData$ | async;
                    track option
                  ) {
                    <ng-option class="option" [value]="option.value">
                      {{ option.label }}
                    </ng-option>
                  }
                </ng-select>
              </ion-col>
            }
          </ion-row>
        </div>
      </div>

      <div class="main-section">
        <div class="table-subheader">
          <div>{{ CONSTANTS.CURRENT_PACKAGES }}</div>
          <div>
            <ion-button (click)="addPackageItem()">
              <ion-icon
                slot="start"
                alt="add-package"
                [src]="SRC.ADD_PACKAGE"
              ></ion-icon>
              {{ CONSTANTS.ADD_PACKAGE }}
            </ion-button>
          </div>
        </div>

        <!-- PULL THIS OUT INTO ITS OWN COMPONENT-->
        <div class="table">
          <div class="table-header">
            <ion-row>
              <ion-col [size]="getHeaderColSize('trackingNumber')">
                {{ CONSTANTS.TRACKING_NUMBER }}
                <span class="required">*</span>
              </ion-col>
              <ion-col [size]="getHeaderColSize('shipperNumber')">
                {{ CONSTANTS.SHIPPER }}
                <span class="required">*</span>
              </ion-col>
              <ion-col [size]="getHeaderColSize('scanCode')">
                {{ CONSTANTS.OVERRIDE_SCAN_CODE }}
              </ion-col>
              <ion-col [size]="getHeaderColSize('description')">
                {{ CONSTANTS.REMARK_DESCRIPTION }}
              </ion-col>
              @if (showTaxId) {
                <ion-col [size]="getHeaderColSize('taxId')">
                  {{ CONSTANTS.TAXID_PFC }}
                </ion-col>
              }
              @if (showTaxId) {
                <ion-col [size]="getHeaderColSize('taxIdNumber')">
                  {{ CONSTANTS.TAXID_PCF_NUMBER }}
                </ion-col>
              }
              <ion-col [size]="getHeaderColSize('paymentType')">
                {{ CONSTANTS.PAYMENT_TYPE }}
              </ion-col>
              <ion-col [size]="getHeaderColSize('amtDue')">
                {{ CONSTANTS.AMOUNT_DUE }}
              </ion-col>
              <ion-col [size]="getHeaderColSize('amtCollected')">
                {{ CONSTANTS.AMOUNT_COLLECTED }}
              </ion-col>
              <ion-col [size]="getHeaderColSize('actions')">
                {{ CONSTANTS.ACTIONS }}
              </ion-col>
            </ion-row>
          </div>

          <div class="form-body">
            @for (item of getControls(); track item; let i = $index) {
              <div formArrayName="data">
                <div [formGroupName]="i" (keyup)="rowKeyPress($event, i)">
                  <ion-row [tabindex]="0">
                    <!-- Tracking Number -->
                    <ion-col [size]="getColSize('trackingNumber')">
                      <ion-input
                        #trackingInput
                        [attr.name]="'trackingNumber'"
                        required
                        class="ion-input-text"
                        type="text"
                        formControlName="trackingNumber"
                        maxlength="18"
                        [ngClass]="{
                          'has-error':
                            (formArray.at(i).get('trackingNumber')?.dirty ||
                              formArray.at(i).get('trackingNumber')?.touched) &&
                            !!formArray.at(i).get('trackingNumber')?.errors,
                        }"
                        (keypress)="
                          commonUtils.preventSpecialCharacters($event)
                        "
                        (keydown)="
                          data.routeDetails[0].type === 'PS' &&
                          !data.routeDetails[0].trackingNumber
                            ? hideScanCode(
                                formArray.at(i).get('trackingNumber'),
                                i
                              )
                            : ''
                        "
                        (paste)="
                          data.routeDetails[0].type === 'PS' &&
                          !data.routeDetails[0].trackingNumber
                            ? hideScanCode(
                                formArray.at(i).get('trackingNumber'),
                                i
                              )
                            : ''
                        "
                        (ionBlur)="updateTrackingNumber(i)"
                      ></ion-input>

                      @if (
                        formArray.at(i).get("trackingNumber")?.dirty ||
                        formArray.at(i).get("trackingNumber")?.touched
                      ) {
                        <div class="required">
                          @if (
                            formArray.at(i).get("trackingNumber")?.errors?.[
                              "required"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                            </span>
                          }
                        </div>

                        @if (
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.hasError("intercepted")
                        ) {
                          <ion-text class="error-text">
                            {{ ERROR_LABELS.INTERCEPTED_TRACKING_NUMBER }}
                            {{ formArray.at(i).get("trackingNumber")?.value }}
                            {{ ERROR_LABELS.RETURN_TO_CENTER }}
                          </ion-text>
                        }

                        @if (
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.hasError("interceptedPackage")
                        ) {
                          <ion-text class="error-text">
                            {{ CONSTANTS.VALIDATIONS.INTERCEPTED_PACKAGE_1 }}
                            {{ formArray.at(i).get("trackingNumber")?.value }}
                            {{ CONSTANTS.VALIDATIONS.INTERCEPTED_PACKAGE_2 }}
                          </ion-text>
                        }

                        @if (
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.hasError("invalidTrackingNo")
                        ) {
                          <ion-text class="error-text">
                            {{ CONSTANTS.VALIDATIONS.INVALID_TRACKING_NUMBER }}
                          </ion-text>
                        }
                        @if (
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.hasError("duplicateTracking")
                        ) {
                          <ion-text class="error-text">
                            {{
                              CONSTANTS.VALIDATIONS.DUPLICATE_TRACKING_NUMBER
                            }}
                          </ion-text>
                        }
                      }
                    </ion-col>
                    <!--  -->
                    <!-- Shipper Number -->
                    <ion-col [size]="getColSize('shipperNumber')">
                      <ion-input
                        required
                        [attr.name]="'shipperNumber'"
                        class="ion-input-text"
                        type="text"
                        formControlName="shipperNumber"
                        minlength="6"
                        maxlength="6"
                        (keypress)="
                          commonUtils.preventSpecialCharacters($event)
                        "
                      >
                      </ion-input>
                      @if (
                        formArray.at(i).get("shipperNumber")?.invalid &&
                        (formArray.at(i).get("shipperNumber")?.dirty ||
                          formArray.at(i).get("shipperNumber")?.touched)
                      ) {
                        <div class="required small-size">
                          @if (
                            formArray.at(i).get("shipperNumber")?.errors?.[
                              "required"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                            </span>
                          }
                          @if (
                            formArray.at(i).get("shipperNumber")?.errors?.[
                              "minlength"
                            ] ||
                            formArray.at(i).get("shipperNumber")?.errors?.[
                              "maxlength"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.INVALID_SHIPPER }}
                            </span>
                          }
                        </div>
                      }
                    </ion-col>
                    <!--  -->
                    <!-- Scan Code -->
                    <ion-col [size]="getColSize('scanCode')">
                      <div class="form-group">
                        <ng-select
                          appearance="outline"
                          class="custom-select scan-codes-select"
                          formControlName="scanCode"
                          [clearable]="false"
                          [required]="true"
                          [items]="scanCodeVals"
                          bindLabel="label"
                          bindValue="value"
                          [loading]="scanCodeVals.length === 0"
                          (change)="scanCodeChanges()"
                        />
                      </div>
                    </ion-col>
                    <!--  -->
                    <!-- Remark/Description -->
                    <ion-col [size]="getColSize('description')">
                      <ion-input
                        class="ion-input-text"
                        [attr.name]="'description'"
                        type="text"
                        formControlName="description"
                        [ngClass]="{
                          'has-error':
                            formArray.at(i).get('description')?.errors !== null,
                        }"
                        (keypress)="preventSpecialCharactersWithSpaces($event)"
                        [maxlength]="15"
                      ></ion-input>
                      @if (
                        formArray.at(i).get("description")?.dirty ||
                        formArray.at(i).get("description")?.touched
                      ) {
                        <div class="required">
                          @if (
                            formArray.at(i).get("description")?.errors?.[
                              "required"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                            </span>
                          }
                        </div>
                      }
                    </ion-col>
                    <!--  -->
                    @if (showTaxId) {
                      <!-- TAXID/PFC -->
                      <ion-col [size]="getColSize('taxId')">
                        <div class="form-group">
                          <ng-select
                            appearance="outline"
                            class="custom-select taxid-select"
                            [formControlName]="'taxidPfc'"
                            [clearable]="false"
                            (change)="onTaxIdTypeChange(i)"
                          >
                            @for (option of TAXID_PFC_LIST; track option) {
                              <ng-option class="option" [value]="option.value">
                                {{ option.label }}
                              </ng-option>
                            }
                          </ng-select>
                        </div>
                      </ion-col>
                      <!--  -->

                      <!-- TAXID/PFC -->
                      <ion-col [size]="getColSize('taxIdNumber')">
                        <ion-input
                          class="ion-input-text"
                          [attr.name]="'taxidPfcNumber'"
                          type="text"
                          formControlName="taxidPfcNumber"
                          [ngClass]="{
                            'has-error':
                              formArray.at(i).get('taxidPfcNumber')?.errors !==
                                null &&
                              (formArray.at(i).get('taxidPfcNumber')?.touched ||
                                formArray.at(i).get('taxidPfcNumber')?.dirty),
                          }"
                          [maxlength]="getMaxLengthForTaxId(i)"
                          (keypress)="preventTaxSpecialCharacters($event)"
                        ></ion-input>
                        @if (
                          (formArray.at(i).get("taxidPfcNumber")?.touched ||
                            formArray.at(i).get("taxidPfcNumber")?.dirty) &&
                          formArray
                            .at(i)
                            .get("taxidPfcNumber")
                            ?.hasError("minlength")
                        ) {
                          <div class="error-text">
                            {{
                              CONSTANTS.VALIDATIONS.MIN_LENGTH.replace(
                                "%s",
                                getMaxLengthForTaxId(i).toString()
                              )
                            }}
                          </div>
                        }
                      </ion-col>
                      <!--  -->
                    }
                    <!-- Payment Type -->
                    <ion-col [size]="getColSize('paymentType')">
                      <div class="form-group">
                        <ng-select
                          appearance="outline"
                          class="custom-select"
                          [formControlName]="'paymentType'"
                          [clearable]="false"
                          [required]="true"
                        >
                          <ng-option class="option" [value]="CONSTANTS.CASH">{{
                            CONSTANTS.CASH
                          }}</ng-option>
                          <ng-option
                            class="option"
                            [value]="CONSTANTS.CHEQUE"
                            >{{ CONSTANTS.CHEQUE }}</ng-option
                          >
                        </ng-select>

                        @if (
                          editTrackingDetailForm.get("scanCode")?.invalid &&
                          (editTrackingDetailForm.get("scanCode")?.dirty ||
                            editTrackingDetailForm.get("scanCode")?.touched)
                        ) {
                          <div class="alert validation-message">
                            @if (
                              editTrackingDetailForm
                                .get("scanCode")
                                ?.hasError("required")
                            ) {
                              <span>
                                {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                              </span>
                            }
                          </div>
                        }
                      </div>
                    </ion-col>
                    <!--  -->

                    <!-- Amount Due -->
                    <ion-col [size]="getColSize('amtDue')" class="amount">
                      <ion-input
                        class="ion-input-text amount-due-collected-field"
                        id="amtDue"
                        [attr.name]="'amtDue'"
                        formControlName="amtDue"
                        maxlength="11"
                        [ngClass]="{
                          'has-error':
                            formArray.at(i).get('amtDue')?.errors !== null &&
                            (formArray.at(i).get('amtDue')?.touched ||
                              formArray.at(i).get('amtDue')?.dirty),
                        }"
                        [min]="0"
                        inputmode="decimal"
                        (keypress)="preventMaxLimitValue($event)"
                      ></ion-input>
                      @if (
                        formArray.at(i).get("amtDue")?.invalid &&
                        (formArray.at(i).get("amtDue")?.dirty ||
                          formArray.at(i).get("amtDue")?.touched ||
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.value?.startsWith("1ZX"))
                      ) {
                        <div class="required" class="required">
                          @if (
                            formArray.at(i).get("amtDue")?.errors?.["required"]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                            </span>
                          }
                        </div>
                      }
                      @if (
                        formArray
                          .at(i)
                          .get("amtDue")
                          ?.hasError("codAmountInvalid")
                      ) {
                        <ion-text class="error-text">
                          {{ CONSTANTS.VALIDATIONS.COD_GREATER_THAN_ZERO }}
                        </ion-text>
                      }
                    </ion-col>
                    <!--  -->
                    <!-- Amount Collected -->
                    <ion-col [size]="getColSize('amtCollected')">
                      <ion-input
                        class="ion-input-text amount-due-collected-field"
                        id="amtCollected"
                        [attr.name]="'amtCollected'"
                        formControlName="amtCollected"
                        [ngClass]="{
                          'has-error':
                            formArray.at(i).get('amtCollected')?.errors !==
                              null &&
                            (formArray.at(i).get('amtCollected')?.touched ||
                              formArray.at(i).get('amtCollected')?.dirty),
                        }"
                        [min]="0"
                        inputmode="decimal"
                        (keypress)="preventMaxLimitValue($event)"
                      ></ion-input>
                      @if (
                        formArray.at(i).get("amtCollected")?.invalid &&
                        (formArray.at(i).get("amtCollected")?.dirty ||
                          formArray.at(i).get("amtCollected")?.touched ||
                          formArray
                            .at(i)
                            .get("trackingNumber")
                            ?.value?.startsWith("1ZX"))
                      ) {
                        <div class="required" class="required">
                          @if (
                            formArray.at(i).get("amtCollected")?.errors?.[
                              "required"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.REQUIRED }}
                            </span>
                          }
                          @if (
                            formArray.at(i).get("amtCollected")?.errors?.[
                              "invalidAmount"
                            ]
                          ) {
                            <span>
                              {{ CONSTANTS.VALIDATIONS.INVALID_AMOUNT }}
                            </span>
                          }
                        </div>
                      }
                    </ion-col>
                    <!--  -->
                    <!-- Actions -->
                    <ion-col
                      [size]="getColSize('actions')"
                      class="actions"
                      (click)="removeRow(i)"
                    >
                      <img
                        [src]="SRC.DELETE"
                        alt="delete"
                      />
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="footer">
        <button
          class="save-button"
          [class]="canSave ? 'dirty' : 'clean'"
          [disabled]="!canSave"
          (click)="saveForm()"
        >
          <img
            [src]="canSave ? SRC.CHECK_BLUE : SRC.CHECK_GREY"
            alt="checkmark"
          />
          <span>{{ CONSTANTS.SAVE }}</span>
        </button>

        <!-- Complete Button -->
        <ion-button
          class="complete-stop-button"
          type="button"
          fill="solid"
          [ngClass]="{
            'btn-disable': !canComplete,
          }"
          [disabled]="!canComplete"
          (click)="completeStop()"
        >
          <ion-icon
            slot="start"
            alt="operations-stop"
            [src]="SRC.OPERATIONS_STOP"
          ></ion-icon>
          <span>{{ CONSTANTS.COMPLETE_STOP }}</span>
        </ion-button>
      </div>
    </form>
  </div>
</app-modal-frame>
